// The tin deal's line under a small tin's Add to Cart (snippets/tin-deal-note):
// shown only while the ad pass is live. It counts the tins once added: the
// deal's own small tins in the basket (data-tin-ids, from deals-rules: a
// clearance tin doesn't count, Michael 2026-10-11) plus the quantity box when
// the box is on a deal small tin, and says the next step (wording Michael
// 2026-10-11, after CS Illustrator's offer line). While it shows, the member
// line above it ([data-tin-deal-hides]) is hidden: same tin prices, said once
// (Michael 2026-10-11). The quantity box repaints it through deal-prices.js's
// quantity listener.

import { unlockState } from './deal-unlock.js'

let items = null
const ids = (el) => new Set((el.dataset.tinIds || '').trim().split('|'))
const tinsIn = (set) => items.reduce((n, i) => n + (set.has(String(i.variant_id)) ? i.quantity : 0), 0)

export function paint(root = document) {
  const live = unlockState() === 'live'
  root.querySelectorAll?.('[data-tin-deal-hides]').forEach((el) => (el.hidden = live))
  root.querySelectorAll?.('[data-tin-deal-note]').forEach((el) => {
    el.hidden = !live
    if (items === null) return
    const set = ids(el)
    const form = el.closest('form')
    const onTin = set.has(form?.querySelector('[name="id"]')?.value)
    const q = onTin ? parseInt(form.querySelector('input[name="quantity"]')?.value, 10) || 1 : 0
    const step = String(Math.min(Math.max(tinsIn(set) + q, 1), 4))
    el.querySelectorAll('[data-tin-deal-when]').forEach((x) => (x.hidden = x.dataset.tinDealWhen !== step))
  })
}

document.addEventListener('cardo:cart', (e) => {
  items = e.detail.cart?.items || []
  paint()
})
document.addEventListener('deal:unlock', () => paint())
document.addEventListener('ui:hydrate', (e) => paint(e.detail?.target || document))
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => paint(), { once: true })
} else {
  paint()
}
